module.exports = __webpack_public_path__ + "static/media/history_6.61c9dc3d.jpg";